import styled from 'styled-components'

export const AriaHiddenLabel = styled.p`
  clip: rect(0 0 0 0);
  clip-path: inset(100%);
  height: 1px;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  border: 0;
`
